import { DateObject } from 'react-multi-date-picker';
import { getEnv } from './getEnv';
import { magicNumbers } from './magicNumbers';
import {
  mapCalendarToCalendars,
  mapCalendarToLocales,
  mapLanguageToCalendar,
} from './mapCalendar';

export const timeDurationTools = (time_duration) => {
  const selectedCalendar = mapLanguageToCalendar[getEnv('REACT_APP_LANGUAGE')];
  const options = {
    calendar: mapCalendarToCalendars[selectedCalendar],
    locale: mapCalendarToLocales[selectedCalendar],
  };
  const now = new DateObject(options);
  const oneMonthTimeDuration = Math.ceil(
    (now - new DateObject(options).subtract(1, 'months')) / 1000
  );
  const threeMonthTimeDuration = Math.ceil(
    (now - new DateObject(options).subtract(3, 'months')) / 1000
  );
  const sixMonthTimeDuration = Math.ceil(
    (now - new DateObject(options).subtract(6, 'months')) / 1000
  );
  const oneYearTimeDuration = Math.ceil(
    (now - new DateObject(options).subtract(12, 'months')) / 1000
  );

  switch (time_duration) {
    case 0:
    case 'today': {
      const hour = new DateObject().format('HH');
      const min = new DateObject().format('mm');
      return {
        from: new DateObject(options)
          .subtract(parseInt(hour), 'hour')
          .subtract(parseInt(min), 'minute'),
        to: now,
        toString: () => 'today',
        toNumber: () => 0,
        days: 1,
      };
    }
    case magicNumbers.SIX_HOURS_IN_SECONDS:
    case '6h':
      return {
        from: new DateObject(options).subtract(6, 'hour'),
        to: now,
        toString: () => '6h',
        toNumber: () => magicNumbers.SIX_HOURS_IN_SECONDS,
        days: 1,
      };
    case magicNumbers.ONE_DAY_IN_SECONDS:
    case '24h':
      return {
        from: new DateObject(options).subtract(1, 'days'),
        to: now,
        toString: () => '24h',
        toNumber: () => magicNumbers.ONE_DAY_IN_SECONDS,
        days: 1,
      };
    case magicNumbers.ONE_WEEK_IN_SECONDS:
    case '1w':
      return {
        from: new DateObject(options)
          .subtract(7, 'days')
          .setHour(0)
          .setMinute(0)
          .setSecond(0),
        to: now,
        toString: () => '1w',
        toNumber: () => magicNumbers.ONE_WEEK_IN_SECONDS,
        days: 7,
      };
    case magicNumbers.TWO_WEEKS_IN_SECONDS:
    case '2w':
      return {
        from: new DateObject(options)
          .subtract(14, 'days')
          .setHour(0)
          .setMinute(0)
          .setSecond(0),
        to: now,
        toString: () => '2w',
        toNumber: () => magicNumbers.TWO_WEEKS_IN_SECONDS,
        days: 14,
      };
    case oneMonthTimeDuration:
    case '1m':
      return {
        from: new DateObject(options)
          .subtract(1, 'months')
          .setHour(0)
          .setMinute(0),
        to: now,
        toString: () => '1m',
        toNumber: () => oneMonthTimeDuration,
        days: oneMonthTimeDuration / magicNumbers.ONE_DAY_IN_SECONDS,
      };
    case threeMonthTimeDuration:
    case '3m':
      return {
        from: new DateObject(options)
          .subtract(3, 'months')
          .setHour(0)
          .setMinute(0)
          .setSecond(0),
        to: now,
        toString: () => '3m',
        toNumber: () => threeMonthTimeDuration,
        days: threeMonthTimeDuration / magicNumbers.ONE_DAY_IN_SECONDS,
      };
    case sixMonthTimeDuration:
    case '6m':
      return {
        from: new DateObject(options)
          .subtract(6, 'months')
          .setHour(0)
          .setMinute(0),
        to: now,
        toString: () => '6m',
        toNumber: () => sixMonthTimeDuration,
        days: sixMonthTimeDuration / magicNumbers.ONE_DAY_IN_SECONDS,
      };
    case oneYearTimeDuration:
    case '12m':
      return {
        from: new DateObject(options)
          .subtract(12, 'months')
          .setHour(0)
          .setMinute(0)
          .setSecond(0),
        to: now,
        toString: () => '12m',
        toNumber: () => oneYearTimeDuration,
        days: oneYearTimeDuration / magicNumbers.ONE_DAY_IN_SECONDS,
      };
    default:
      return {
        from: undefined,
        to: undefined,
        toString: () => undefined,
        toNumber: () => undefined,
        days: 1,
      };
  }
};
